import { object } from 'prop-types';

export const useGetRecordings = contentListResponse => {
  const { recordings, series, time_used } = contentListResponse?.response || {};

  const toOrderByDate = () => {
    try {
      const recordingFilter = recordings?.filter(
        recordingObj =>
          recordingObj?.status === 'ingested' ||
          recordingObj?.status === 'recording' ||
          recordingObj?.status === 'scheduled',
      );

      const recordingsFormat = recordingFilter?.map(recordingObj => ({
        time_used: time_used,
        ...recordingObj,
      }));

      const seriesFormat = series?.map(recordingObj => ({
        time_used: time_used,
        ...recordingObj,
      }));

      const dataRecordings = recordingsFormat || [];
      const dataSeries = seriesFormat || [];

      const allRecordingsAndSeries = [...dataRecordings, ...dataSeries];
      return allRecordingsAndSeries;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const data = toOrderByDate();

  return { groups: data };
};

useGetRecordings.propTypes = {
  contentListResponse: object,
};
